/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SearchCompanyRequest = {
  properties: {
    search: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
